import React from 'react';

//*Mui
import { Modal, Box, Tabs, Tab } from '@mui/material';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../Redux Store/actions';

//*files
import Close from '../../Components/Icons/Close';
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect } from 'react';
import cssClasses from './ViewInventoryDetails.module.css';

function ViewInventoryDetails({ open, handleClose, data }) {
  const [tabValue, setTabValue] = useState('Sold');
  const [tabs, setTab] = useState(['Sold', 'UnSold']);
  const [soldDetails, setSoldDetails] = useState([]);
  const [UnsoldDetails, setUnsoldDetails] = useState([]);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [columns, setColumns] = useState([]);
  const style = {
    position: 'absolute',
    top: '50%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '95%',
    width: '70%',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
  };

  const dataGridStyles = {
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    border: '1px solid #EAECF0 !important',
    fontWeight: '400',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: '#667085',
    fontFamily: 'Inter-Medium',
    borderRadius: '8px',
    '& div[data-colindex="1"]': {
      color: '#101828',
      fontWeight: '500',
    },
    '& .MuiDataGrid-virtualScrollerRenderZone': {
      '& .MuiDataGrid-row': {
        borderBottom: '1px solid #EAECF0',
        background: '#FFFFFF',
        /* Shadow/xl */

        // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        borderRadius: '1rem',

        //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
        //   backgroundColor: "#FFFFFF",
      },
      '& .MuiDataGrid-row.Mui-selected:hover': {
        borderBottom: '1px solid #EAECF0',
        backgroundColor: '#FFFFFF',
        // "&:nth-of-type(2n+1)": {
        //   backgroundColor: "rgba(249, 250, 251, 1)",
        // },
      },
    },
    '& .MuiDataGrid-iconSeparator ': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeader:hover': {
      '& .MuiDataGrid-menuIcon': {
        visibility: 'hidden',
      },
    },

    '&  .MuiDataGrid-columnHeaders': {
      background: '#F9FAFB',
      /* Gray/200 */
      border: '1px solid #EAECF0',
      /* Shadow/xl */
      // boxShadow:
      //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      // borderRadius: "8px",

      marginBottom: '1rem',
      borderBottom: '6px solid #EAECF0',
    },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-checkboxInput': {
      '& svg': {
        width: '2rem',
        height: '2rem',
        background: '#FFFFFF',
      },
    },
    // "& .MuiTablePagination-displayedRows": {
    //   display: "none",
    // },
    '& .MuiDataGrid-footerContainer': {
      '& .MuiTablePagination-displayedRows ': {
        display: 'none',
      },
      '& .MuiDataGrid-selectedRowCount': {
        visibility: 'hidden ',
      },
    },
    "&  [title='Sort']": {
      //visibility:"hidden",
      display: 'none',
      cursor: 'none',
    },
    "& [title='Go to previous page']": {
      borderRadius: '0',
      border: '1px solid #EAECF0',
      borderRadius: '0.8rem',
      marginRight: '0.5rem',
    },
    "& [title='Go to next page']": {
      borderRadius: '0',
      border: '1px solid #EAECF0',
      borderRadius: '0.8rem',
      marginRight: '0.5rem',
    },
    "& [title='Go to previous page']:after": {
      content: "'Previous'",
      marginLeft: '1rem',
    },
    "& [title='Go to next page']:before": {
      content: "'Next'",
      marginRight: '1rem',
    },
    '& .MuiDataGrid-columnHeader': {
      padding: '0 4rem',

      '&:focus': {
        outline: 'none',
      },
    },
    '&  .MuiDataGrid-row ': {
      maxHeight: '72px !important',
      minHeight: '72px !important',
    },
    '& .MuiDataGrid-cell': {
      padding: '0 4rem',
      minHeight: '72px !important',
      maxHeight: '72px !important',
      '&:focus': {
        outline: 'none',
      },
    },
    '& .MuiButtonBase-root': {
      fontSize: '1.6rem',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
    },
    '& .MuiDataGrid-cell': {
      padding: '0 2rem',
      minHeight: '72px !important',
      maxHeight: '72px !important',
      '&:focus': {
        outline: 'none',
      },
    },
    '& .MuiDataGrid-columnHeader': {
      padding: '0 1rem',

      '&:focus': {
        outline: 'none',
      },
    },
  };

  useEffect(() => {
    InventoryDetails();
    // console.log("data" , data)
  }, [tabValue]);
  function numDifferentiation(val) {
    if (val >= 10000000) val = (val / 10000000).toFixed(2) + ' Cr';
    else if (val >= 100000) val = (val / 100000).toFixed(2) + ' Lac';
    else if (val >= 1000) val = (val / 1000).toFixed(2) + ' K';
    return val;
  }

  function InventoryDetails() {
    // console.log('data', data);
    if (tabValue === 'Sold') {
      const fd = data
        .filter(
          (f) =>
           ( f?.inventoryStatusId?.status === 'Kyc Pending' ||
            f?.inventoryStatusId?.status === 'Preselected' ||
            f?.inventoryStatusId?.status === 'Sold' ||
            f?.inventoryStatusId?.status === 'Payment Pending' ||
            f?.inventoryStatusId?.status === 'Kyc Done') && f?.leadId !== null
        )
        .map((ele, i) => ({
          ...ele,
          id: ele.unitId,
          SalesPerson: ele.leadId?.userId?.name,
          Source: ele.leadId?.leadType,
          Area: ele.chargeableArea.toFixed(2),
          UnitNoVal: ele.unitNo,
          Wing: ele.wingId?.wingName,
          Value: ele.totalCost ? numDifferentiation(ele.totalCost) : '0',
        }));

        // console.log('fd', fd);
      setSoldDetails([...fd]);
      setColumns(SoldValues);
    } else {
      const sd = data
        .filter(
          (f) =>
            (f?.inventoryStatusId?.status === 'Available' ||
            f?.inventoryStatusId?.status === 'On Hold' ||
            f?.inventoryStatusId?.status === 'Reserved' ||
            f?.inventoryStatusId?.status === 'Locked') && f?.leadId === null
        )
        .map((elm, i) => ({
          ...elm,
          id: elm.unitId,
          Area: elm.chargeableArea.toFixed(2),
          UnitNoVal: elm.unitNo,
          Wing: elm.wingId?.wingName,
          Value: elm.totalCost ? numDifferentiation(elm.totalCost) : '0',
        }));
      //   console.log("sd" , sd)
      setUnsoldDetails([...sd]);
      setColumns(UnSoldValues);
    }
  }

  const tabChange = (event, newValue) => {
    // console.log(newValue);
    setTabValue(newValue);
  };
  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: 'Inter-Medium !important',
            fontStyle: 'normal !important',
            fontWeight: '500 !important',
            fontSize: '1.4rem !important',
            lineHeight: '2rem !important',
            textTransform: 'none !important',
          },
        ]}
      />
    );
  });

  const SoldValues = [
    {
      field: 'SalesPerson',
      headerName: 'Sales Person',
      width: 240,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} whiteSpace={'break-spaces'}>
            {params?.row?.SalesPerson ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'Source',
      headerName: 'Source',
      width: 140,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} whiteSpace={'break-spaces'}>
            {params?.row?.Source ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'Area',
      headerName: 'Area',
      width: 140,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle1} whiteSpace={'break-spaces'}>
            {`${params?.row?.Area} sq.ft` ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'UnitNoVal',
      headerName: 'Unit No',
      width: 140,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} whiteSpace={'break-spaces'}>
            {params?.row?.UnitNoVal ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'Wing',
      headerName: 'Wing',
      width: 140,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} whiteSpace={'break-spaces'}>
            {params?.row?.Wing ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'Value',
      headerName: 'Value',
      width: 140,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} whiteSpace={'break-spaces'}>
            {`₹ ${params?.row?.Value}` ?? ''}
          </Box>
        );
      },
    },
  ];

  const UnSoldValues = [
    {
      field: 'Area',
      headerName: 'Area',
      width: 140,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle1} whiteSpace={'break-spaces'}>
            {`${params?.row?.Area} sq.ft` ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'UnitNoVal',
      headerName: 'Unit No',
      width: 140,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} whiteSpace={'break-spaces'}>
            {params?.row?.UnitNoVal ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'Wing',
      headerName: 'Wing',
      width: 140,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} whiteSpace={'break-spaces'}>
            {params?.row?.Wing ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'Value',
      headerName: 'Value',
      width: 140,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} whiteSpace={'break-spaces'}>
            {`₹ ${params?.row?.Value}` ?? ''}
          </Box>
        );
      },
    },
  ];

  function getMoreData() {}

  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleClose();
          }
        }}
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.HeaderTitle} m={1}>
                  Product - {data[0]?.inventoryTypeId?.type}
                </Box>{' '}
              </Box>
              <Box
                ml={'auto'}
                mt={2}
                mr={1}
                onClick={handleClose}
                style={{ cursor: 'pointer' }}
              >
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

          <Box margin={'0rem 2rem'} className={cssClasses.headerDiv}>
            <Tabs
              value={tabValue}
              onChange={tabChange}
              variant='scrollable'
              scrollButtons='auto'
              aria-label='scrollable auto tabs example'
              sx={[
                {
                  borderBottom: '1px solid #EAECF0 !important',
                },
              ]}
            >
              {tabList}
            </Tabs>
          </Box>

          <Box style={{ height: '77%', width: '96%' }}>
            <Box style={{ height: '100%', width: '100%' }}>
              <Box
                style={{ height: '100%', width: '100%', margin: '0.5rem 2rem' }}
              >
                <DataGrid
                  rows={tabValue === 'Sold' ? soldDetails : UnsoldDetails}
                  columns={columns}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  page={pageMaintain}
                  onPageChange={(_page) => {
                    setPageMaintain(_page);
                    if (pageNumber < _page) {
                      getMoreData(_page);
                    }
                  }}
                  sx={[dataGridStyles]}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default ViewInventoryDetails;
